define([
	"dojo/_base/declare",
	"csi",
	"csi/_base/underscore",
	"csi/config",
	"csi/datasheet/Widget"
], function(declare, csi, _, config, DataSheetWidget) {

	return declare(DataSheetWidget, {
		// Boolean: this is purely a print view, so by default custom views should be shared
		prefNestedSiteDefaults: true,

		// Boolean: preserve node context of nested TestsBySection views
		prefNestedNodeContext: true,

		// view id that is going to be repeated per subtype
		// subtypedViewId

		// the name of the relation to the subtyped class
		// relationToSubtypedClass

		// the name of the relation from the subtyped class to Subtype
		// relationToSubtype

		// the name of the class that has subtypes
		// subtypedClassName

		// property used in the setViewNode function
		// viewNodePropertyName

		setNestedViewDefault: function(/*csi.view.Widget*/view) {
			// summary: return false if view is for test type that is not one of the test run sections;
			// this will stop views of test types not in this test run from loading (only there for custom view purposes)
			// similar code is in InspectionBatchDataSheet
			var b = this.inherited(arguments);
			if (!b) {
				return false;
			}

			var viewId = view.defView.getId();
			if (viewId == this.subtypedViewId) {
				return !!view.getViewNode();
			}

			return true;
		},

		_processKey: function(/*Context*/ctx, /*String*/key, /*Object*/def, /*DOMNode*/domNode) {
			// summary: add view for each subtype, and associate with appropriate section if it exists
			// similar code is in InspectionBatchDataSheet
			if (key == this.subtypedViewId) {
				var self = this;
				var sectionUrls = ctx.getNode()[this.relationToSubtypedClass];
				var sections = ctx.cache.getNodes(sectionUrls);
				var nSections = sections.length;
				var sectionMap = csi.hashArray(sections, this.relationToSubtype, "$URL");
				var store = config.getSubtypeStore(this.subtypedClassName);
				var params;

				if (store) {
					var labelProperty = store.labelProperty;

					params = store.query(store.getNonEmptyQuery()).map(function(item, i) {
						// order the views based on the section order if present, otherwise alphabetical
						var subtype = item[labelProperty];
						var sectionUrl = sectionMap[store.getIdentity(item)];
						var n = _.indexOf(sectionUrls, sectionUrl);

						var viewRefParam = {
							_sortOrder: (n === -1) ? (nSections + i) : n,
							prefNodeContext: subtype,
							compositeCustomViewName: subtype,
							secondaryViewId: subtype,
							bSkipRender: !sectionUrl // do not populate headings for subtypes that are not displayed
						};

						viewRefParam[self.viewNodePropertyName] = sectionUrl || csi.EMPTY_URL;

						return viewRefParam;
					});
				} else {
					params = [];
				}

				params = csi.sort(params, "_sortOrder");

				this._processViewRefForEach(ctx, def, domNode, params, _.pluck(params, "compositeCustomViewName"));
			} else {
				this.inherited(arguments);
			}
		}
	});
});